import { api } from '@/lib/api';
import {
  TedSearchParams,
  ExternalSearchResult,
} from '../types/opportunity.types';

const BASE_URL = '/tm/import';

/**
 * Service pour la recherche d'opportunités TED (Europe)
 */
export const tedSearchService = {
  async search(params: TedSearchParams): Promise<ExternalSearchResult> {
    const searchParams = new URLSearchParams();

    if (params.fullText) searchParams.set('fullText', params.fullText);
    if (params.cpvCodes?.length) {
      searchParams.set('cpvCodes', params.cpvCodes.join(','));
    }
    if (params.contractNature?.length) {
      searchParams.set('contractNature', params.contractNature.join(','));
    }
    if (params.documentType) searchParams.set('documentType', params.documentType);
    if (params.countries?.length) {
      searchParams.set('countries', params.countries.join(','));
    }
    if (params.nutsCodes?.length) {
      searchParams.set('nutsCodes', params.nutsCodes.join(','));
    }
    if (params.buyerName) searchParams.set('buyerName', params.buyerName);
    if (params.procedureType) searchParams.set('procedureType', params.procedureType);

    if (params.publicationAfter) searchParams.set('publicationAfter', params.publicationAfter);
    if (params.publicationBefore) searchParams.set('publicationBefore', params.publicationBefore);
    if (params.deadlineAfter) searchParams.set('deadlineAfter', params.deadlineAfter);
    if (params.deadlineBefore) searchParams.set('deadlineBefore', params.deadlineBefore);

    if (params.page) searchParams.set('page', String(params.page));
    if (params.pageSize) searchParams.set('pageSize', String(params.pageSize));
    if (params.sortField) searchParams.set('sortField', params.sortField);
    if (params.reverseOrder) searchParams.set('reverseOrder', 'true');

    const response = await api.get<ExternalSearchResult>(
      `${BASE_URL}/search/ted?${searchParams.toString()}`
    );
    return response.data;
  },
};
